import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-bubble',
  templateUrl: './review-bubble.component.html',
  styleUrls: ['./review-bubble.component.scss']
})
export class ReviewBubbleComponent implements OnInit {

  
  constructor() { }

  ngOnInit(): void {

  }

}
